import React, { Component } from 'react'
import Chart from 'react-apexcharts'
import moment from 'moment'
import { isMobile, isTablet } from 'react-device-detect'

class ProgessChart extends Component {
  constructor(props) {
    super(props)

    this.updateCharts = this.updateCharts.bind(this)

    const types = ['', 'Brzuch', 'Biodra', 'Uda']
    const types_backend = [
      '',
      'belly_circumference',
      'hip_circumference',
      'thigh_circumference',
    ]

    this.state = {
      clickedDimension: null,
      optionsMixedChart: {
        colors: ['#a1ff68'],
        chart: {
          zoom: {
            enabled: false,
          },
          id: 'basic-bar',
          toolbar: {
            show: false,
          },
          events: {
            click: (seriesIndex, dataPointIndex, config) => {
              if (this.props.feeds && this.props.feeds[config.dataPointIndex]) {
                const clickedPointData =
                  this.props.feeds[config.dataPointIndex].creation_datetime

                const clickedPointId =
                  this.props.feeds[config.dataPointIndex].id

                this.props.updateClickedData({
                  type: types[this.props.progressMode],
                  date: clickedPointData,
                  id: clickedPointId,
                  value:
                    this.props.feeds[config.dataPointIndex][
                      types_backend[this.props.progressMode]
                    ],
                  dimensionNumber: config.dataPointIndex,
                  images: this.props.feeds[config.dataPointIndex].photos,
                })
              }
            },
          },
        },
        legend: {
          show: false,
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
          },
        },
        stroke: {
          width: [2, 0, 0],
          background: 'red',
        },
        markers: {
          size: 6,
          strokeWidth: 3,
          fillOpacity: 0,
          strokeOpacity: 0,
          hover: {
            size: 8,
          },
        },
        xaxis: {
          show: true,
          tickPlacement: 'on',
          type: 'numeric',
        },
        yaxis: {
          type: 'numeric',
          show: false,
          tickAmount: 5,
          min: 0,
          max: this.maxVal,
        },
      },
      seriesMixedChart: [
        {
          name: 'Brzuch',
          data: [],
          maxVal: 200,
        },
      ],
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50, 49, 60, 70, 91]
        }
      ]
    }

    this.componentDidMount = () => {
      this.rerenderChart()
    }

    this.componentDidUpdate = (prevProps, prevState) => {
      if (
        prevProps.progressMode != this.props.progressMode ||
        prevProps.feeds.length != this.props.feeds.length
      ) {
        this.rerenderChart()
      }
    }
  }

  extractData = (mode) => {
    let data = []
    let type = ''
    let maxVal = 0

    switch (mode) {
      case 'belly':
        if (this.props.feeds.length) {
          this.props.feeds.forEach((feed, i) => {
            maxVal =
              feed.belly_circumference > maxVal
                ? feed.belly_circumference
                : maxVal
            data = [...data,  feed.belly_circumference]
            type = 'Brzuch'
          })
        }
        break
      case 'hip':
        if (this.props.feeds.length) {
          this.props.feeds.forEach((feed, i) => {
            maxVal =
              feed.hip_circumference > maxVal ? feed.hip_circumference : maxVal
            data = [...data, feed.hip_circumference]
            type = 'Biodra'
          })
        }
        break
      case 'thigh':
        if (this.props.feeds.length) {
          this.props.feeds.forEach((feed, i) => {
            data = [...data,  feed.thigh_circumference]
            maxVal =
              feed.thigh_circumference > maxVal
                ? feed.thigh_circumference
                : maxVal
            type = 'Uda'
          })
        }
        break
      default:
        break
    }

    this.setState({
      seriesMixedChart: [
        {
          name: type,
          data: data,
        },
      ],
    })
  }

  rerenderChart = () => {
    switch (this.props.progressMode) {
      case 1:
        this.extractData('belly')
        break
      case 2:
        this.extractData('hip')
        break
      case 3:
        this.extractData('thigh')
        break
      default:
        break
    }
  }

  updateCharts() {

    const newMixedSeries = []

    this.setState({
      seriesMixedChart: newMixedSeries,
    })
  }

  render() {

    return (
      <div className="app">
        <div className="row">
          <div className="col mixed-chart">
            <Chart
              options={this.state.optionsMixedChart}
              series={this.state.seriesMixedChart}
              type="line"
              width={
                isMobile && !isTablet
                  ? '300'
                  : isTablet
                  ? window.innerWidth / 1.6
                  : window.innerWidth / 2.8
              }
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ProgessChart
